import { ArrowLeft } from 'lucide-react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  OverView, TxpProgressTracker,
  ProgressAndActivityCard, PdfViewerCard
} from 'components/TreatmentPlan';
import { connect } from 'react-redux';
import { TreatmentPlansActions } from 'store/actions';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { PortalSpinner } from 'components/PortalSpinner';

let enhancer = connect(null, { ...TreatmentPlansActions });

const TreatmentPlanShow = ({ showTreatmentPlan }) => {
  const navigate = useNavigate();
  const { encodedResourceId: encodedTreatmentPlanId } = useParams();
  const [treatmentPlan, setTreatmentPlan] = useState(null)
  const [isPdfRefereshing, setIsPdfRefereshing] = useState(false)

  let { attributes } = treatmentPlan || {}

  useEffect(() => {
    loadTreatmentPlan()
  }, [encodedTreatmentPlanId]);

  const loadTreatmentPlan = async () => {
    try {
      const { data: _treatmentPlan } = await showTreatmentPlan(encodedTreatmentPlanId);
      setTreatmentPlan(_treatmentPlan);

    } catch (error) {
      toast.error(error.errors || 'Failed to load treatment plan');
    }
    setIsPdfRefereshing(false)
  };

  return (
    <div className="space-y-5">
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="inline-flex rounded-xl text-secondary-700 p-1.5 hover:bg-base-200 transition-colors"
      >
        <ArrowLeft size={20} />
      </button>

      {!treatmentPlan ? <PortalSpinner /> :
        <div className="grid grid-cols-1 lg:grid-cols-[60fr_40fr] gap-6 items-start">
          <div className="space-y-4">
            <OverView treatmentPlan={attributes} />
            <TxpProgressTracker treatmentPlan={attributes} />
            <ProgressAndActivityCard treatmentPlan={attributes} />
          </div>

          <PdfViewerCard
            onRefresh={() => { setIsPdfRefereshing(true); loadTreatmentPlan() }}
            isRefreshing={isPdfRefereshing}
            treatmentPlan={treatmentPlan}
            setTreatmentPlan={setTreatmentPlan}
          />
        </div>
      }
    </div>
  )
}

export default enhancer(TreatmentPlanShow)
